import { REQUEST, RECEIVE, RECEIVE_PROMOTED, UPDATE_FILTERS} from '../constants/action_types';
import * as api from '../api/api';
import moment from 'moment';

const request = () => ({
    type: REQUEST
});

const receive = (optimalles) => ({
    type: RECEIVE,
    optimalles
});

const receivePromoted = (optimalles) => ({
    type: RECEIVE_PROMOTED,
    optimalles
});

const updateFilters = (filters) => ({
    type: UPDATE_FILTERS,
    filters
});

const setSelectedTheme = (theme) =>(dispatch, getState)=> {
    const filters = getState().filters;

    return dispatch(updateFilters({
        ...filters,
        theme
    }))
};

const setSelectedHike = (hike) =>(dispatch, getState)=> {

    const filters = getState().filters;

    return dispatch(updateFilters({
        ...filters,
        hike
    }))
};

const setConfirmed = (confirmed) =>(dispatch, getState)=> {
    const filters = getState().filters;

    return dispatch(updateFilters({
        ...filters,
        confirmed
    }))
};

const setDateRange = (range) =>(dispatch, getState)=> {
    const filters = getState().filters;

    return dispatch(updateFilters({
        ...filters,
        from: moment(range.from).format(),
        to: moment(range.to).format()
    }))
};

const fetchOptimalles = () => (dispatch, getState) => {
    dispatch(request());

    return api.fetchOptimalles(getState().filters, getState().nextPage)
        .then(response => response.json())
        .then(optimalles => dispatch(receive(optimalles)))
};

const fetchPromotedOptimalles = () => dispatch => {
    dispatch(request());

    return api.fetchPromotedOptimalles()
        .then(response => response.json())
        .then(optimalles => dispatch(receivePromoted(optimalles)))
};

export {
    fetchOptimalles,
    fetchPromotedOptimalles,
    setSelectedTheme,
    setSelectedHike,
    setConfirmed,
    setDateRange
};
